import React from 'react';
import "./PrivacyPolicy.css";
export const PrivacyPolicy = () => {


    return (
        <main>
            I collect no data from my apps.
        </main>
    )}